var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registration-closed"},[_c('b-notification',[_vm._v(" Registration for this event is currently closed. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }